import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import TextInput from "../TextInput";
import Cookies from "universal-cookie";

const api_base = process.env.API_URL;
const client_base = process.env.BASE_URL;

export default class ForgotPwContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      message: "",
      display_error: false,
      display_notice: false,
    };
  }

  requestToken = () => {
    let body = { user: { email: this.state.email } };
    const url = api_base + "users/request_pw_reset";
    const reqOptions = {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };
    this.api_call(url, reqOptions)
      .then((data) => {
        console.log("data", data);
        if (data.success) {
          this.setState({
            message: data.message,
            display_notice: true,
            display_error: false,
          });
        } else {
          this.setState({
            message: data.errors,
            display_notice: false,
            display_error: true,
          });
        }
      })
      .catch((err) => {
        let state = this.state;
        state["display_notice"] = false;
        state["display_error"] = true;
        state["message"] = "Request for reset link failed.";
        this.setState(state);
      });
  };

  handleTextChange = (key, event) => {
    let state = this.state;
    state[key] = event.target.value;
    this.setState(state);
  };

  api_call = (url, reqOptions) => {
    return new Promise((resolve, reject) => {
      try {
        fetch(url, reqOptions).then((res) => {
          res.json().then((data) => {
            resolve(data);
          });
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  render() {
    let { email, message, display_error, display_notice } = this.state;

    const page_title = "Forgot Password";
    const requestBtn = (
      <button
        className="btn btn-success col-4 mt-4"
        type="submit"
        onClick={this.requestToken}
      >
        Request Password Reset Link
      </button>
    );

    const notice =
      display_error || display_notice ? (
        <div
          role="alert"
          className={
            "card inner-buffer " +
            (display_error ? "alert alert-danger" : "alert alert-success")
          }
        >
          {message}
        </div>
      ) : (
        ""
      );

    const pwForm = (
      <div className="card inner-buffer w-50">
        <TextInput
          valText={email}
          // inputType="text"
          editMode={true}
          fieldName="email"
          labelText="Email:"
          handleChange={this.handleTextChange}
        />
        {requestBtn}
      </div>
    );

    return (
      <div className="container">
        {notice}
        <h1>{page_title}</h1>
        {pwForm}
      </div>
    );
  }
}
